import { useI18n } from '@change-corgi/core/react/i18n';

import { usePsfPromoteOrSharePageData } from 'src/app/pages/psf/promoteOrShare/pageContext';

type Result = ModelHookResult<{
	title: string;
}>;

export function usePageMeta(): Result {
	const { translate } = useI18n();
	const {
		data: {
			petition: { ask },
		},
	} = usePsfPromoteOrSharePageData();

	return {
		data: {
			title: `${translate('fe.pages.sponsors.title', { petition_title: ask })}`,
		},
	};
}
